const DEVICE_ID_KEY = 'ac_device_id';

function createFallbackId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

let inMemoryDeviceId: string | null = null;

export function getDeviceFingerprint(): string {
  if (typeof window === 'undefined') return 'server';

  let deviceId: string | null = null;
  try {
    deviceId = localStorage.getItem(DEVICE_ID_KEY);
  } catch {
    deviceId = inMemoryDeviceId;
  }

  if (!deviceId) {
    deviceId = crypto.randomUUID?.() ?? createFallbackId();
    try {
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    } catch {
      inMemoryDeviceId = deviceId;
    }
  }

  const timezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown-timezone';

  return [
    deviceId,
    navigator.userAgent,
    navigator.language,
    `${screen.width}x${screen.height}`,
    timezone,
  ].join('|');
}

export function discardLocalDeviceFingerprint(): void {
  try {
    localStorage.removeItem(DEVICE_ID_KEY);
  } catch {
    // noop
  }
}
